
import React, { useCallback, useContext, useMemo, useState } from "react";
import { expenseJobOrderColumns } from "./dailyJobDialogColumns";
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand";
import { Box, Button, IconButton, Typography } from "@mui/material";
import { BoxFC, BoxFR } from "components/BoxCustom";
import { AddCircleRounded, PlaylistAddCircleRounded } from "resource/muiImport";
import ExpenseJobOrderDialogV2 from "pages/Menu3/AddJobOrderExpenseV2/ExpenseJobOrderDialogV2";
import AddExpenseTableDialog from "pages/Menu3/AddJobOrderExpense/AddExpenseTableDialog";
import { expenseJobOrderApiNm } from "constants/expenseJobOrderConstant";
import { GlobalStateContext } from "contexts/GlobalStateContext";
import { alertConfirmDelete, alertWarning } from "components/Alert";

let selectedExpJobOrdId = null;
let expJobOrdData = {}
let selectedJobOrdId = null

const XJOCComponent = ({ xjoDataTable, onPettyCashFinish, jobOrdId, compact }) => {

  const { ax } = useContext(GlobalStateContext);
  const [dialogExpenseJobOrderOpen, setDialogExpenseJobOrderOpen] = useState(false);
  const [dialogAddExpenseTableOpen, setDialogAddExpenseTableOpen] = useState(false);

  const xjoDataTableFiltered = useMemo(() => {
    // return xjoDataTable
    return xjoDataTable.filter(xjo => xjo.IsFromOpr)
  }, [xjoDataTable])

  const handleAddExpenseJobOrder = useCallback(() => {
    const foundInvId = xjoDataTable.find(xjo => xjo.InvId)
    if (foundInvId) {
      alertWarning("ใบงานนี้มีการออกใบแจ้งหนี้แล้ว กรุณาแจ้งทีมบัญชีเพื่อทำการออกใบแจ้งหนี้เพิ่ม")
    }
    selectedExpJobOrdId = null;
    expJobOrdData = null;
    selectedJobOrdId = jobOrdId
    setDialogExpenseJobOrderOpen(true);
  }, [xjoDataTable, jobOrdId])

  const handleXJOCellClick = useCallback(({ row, field }) => {
    if (field === "ShowDetail") {
      selectedExpJobOrdId = row.ExpJobOrdId;
      expJobOrdData = row;
      setDialogExpenseJobOrderOpen(true);
    }
  }, [])

  
  const onXJODialogFinish = useCallback(async (data) => {
    if (data) {
      console.log("data", data);
      // const jobOrdIds = joSelection.length > 0? joSelection: [data.JobOrdId]
      if (data.ExpJobOrdId > 0) {
        if (data.IsDel && data.ExpJobOrdId) {
          alertConfirmDelete(async () => {
            const value = await ax.post(expenseJobOrderApiNm.deleteExpenseJobOrder, { ExpJobOrdIds: [data.ExpJobOrdId] })
            if (value.data) {
              onPettyCashFinish()
            }
          })
        } else {
          const postdata = {
            ...data,
            ExpJobOrdIds: [data.ExpJobOrdId],
            getArgs: { ExpJobOrdId: data.ExpJobOrdId }
          }
          const value = await ax.post(expenseJobOrderApiNm.updateExpenseJobOrderBulk, postdata)
          if (value.data) {
            onPettyCashFinish()
          }
        }
      } else {
        data.IsFromOpr = 1;
        data.JobOrdId = jobOrdId
        ax.post(expenseJobOrderApiNm.insertExpenseJobOrder, data).then((value) => {
          if (value.data) {
            onPettyCashFinish()
          }
        })
      }

    }
  }, [ax, onPettyCashFinish, jobOrdId])
  const handleAddExpTable = useCallback(() => {
    const foundInvId = xjoDataTable.find(xjo => xjo.InvId)
    if (foundInvId) {
      alertWarning("ใบงานนี้มีการออกใบแจ้งหนี้แล้ว กรุณาแจ้งทีมบัญชีเพื่อทำการออกใบแจ้งหนี้เพิ่ม")
    }
    setDialogAddExpenseTableOpen(true)
  }, [xjoDataTable])

  const onAddExpTableDialogFinish = useCallback(async (dataTable) => {
    if (!dataTable || dataTable.length === 0) return
    const postData = {
      argsArr: dataTable.map(item => ({
        ...item,
        JobOrdId: jobOrdId,
        IsFromOpr: 1,
      })),
      getArgs: { JobOrdIds: [jobOrdId] },
      NoUpdate: true,
    }
    const value = await ax.post(expenseJobOrderApiNm.insertUpdateExpenseJobOrderBulk, postData)
    if (value.data) {
      onPettyCashFinish()
    }
  }, [ax, jobOrdId, onPettyCashFinish])

  const dialogs = (
    <>
      <ExpenseJobOrderDialogV2
        dialogOpen={dialogExpenseJobOrderOpen}
        selectedExpJobOrdId={selectedExpJobOrdId}
        setDialogOpen={setDialogExpenseJobOrderOpen}
        onFinish={onXJODialogFinish}
        expJobOrdData={expJobOrdData}
        selectedJobOrdId={selectedJobOrdId}
      />
      <AddExpenseTableDialog
        dialogOpen={dialogAddExpenseTableOpen}
        setDialogOpen={setDialogAddExpenseTableOpen}
        onFinish={onAddExpTableDialogFinish}
        jobOrdIds={[jobOrdId]}
      />
    </>
  )

  if (compact) {
    return (
      <BoxFC sx={{ gap: 1 }}>
        <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 1 }}>
          <Typography sx={{ fontWeight: 700, fontSize: 16 }}>รายได้</Typography>
          <Box flex={1} />
          <Button startIcon={<AddCircleRounded />} onClick={handleAddExpenseJobOrder}>เพิ่ม</Button>
          <Button startIcon={<PlaylistAddCircleRounded />} onClick={handleAddExpTable}>เพิ่มหลายรายการ</Button>
        </Box>
        <DataGridCellExpand
          autoHeight
          density="compact"
          hideFooter
          hideToolbar
          rows={xjoDataTableFiltered}
          columns={expenseJobOrderColumns}
          onCellClick={handleXJOCellClick}
        />
        {dialogs}
      </BoxFC>
    )
  }

  return (
    <BoxFC flex={1.2} sx={{ gap: 0, mb: 0.5 }}>
      <BoxFR sx={{ gap: 1 }}>
        <Typography fontWeight="bold">รายได้</Typography>
        <IconButton sx={{ p: 0 }} onClick={handleAddExpenseJobOrder}>
          <AddCircleRounded color="primary" />
        </IconButton>
        <IconButton sx={{ p: 0 }} onClick={handleAddExpTable}>
          <PlaylistAddCircleRounded color="primary" />
        </IconButton>
      </BoxFR>
      <Box flex={1}>
        <DataGridCellExpand
          density="compact"
          hideFooter
          hideToolbar
          rows={xjoDataTableFiltered}
          columns={expenseJobOrderColumns}
          onCellClick={handleXJOCellClick}
        />
      </Box>

      {dialogs}
    </BoxFC>
  )
}

export default React.memo(XJOCComponent);